import React, { DependencyList, ForwardedRef, MutableRefObject } from 'react'

export enum FormState {
  ERROR = 'ERROR',
  VALID = 'VALID',
}
export enum FormValidationAction {
  ALWAYS = 'ALWAYS',
  BLUR = 'BLUR',
}

export interface FormValidationState {
  message?: string
  state: FormState
}
export interface FormValidation {
  validationResponses: FormValidationState[]
  validity: FormState
}

export type FormValidationFunction<T> = (value: T | undefined, translator?) => FormValidationState
// export type FormValidationFunction = FormValidationFn<unknown>

export interface FormCollectionActions {
  validate: () => boolean
}

export interface FormCollectionProps<T extends {}> {
  className?: string
  formCollectionActionsRef?: MutableRefObject<FormCollectionActions | null>
  id: string
  model: T
  onBlur?: (model: T, valid: boolean, validationResponses: Record<string, FormValidation>, activeID: string | null) => void
  onChange?: (model: T, valid: boolean, validationResponses: Record<string, FormValidation>, activeID: string | null) => void
  onSubmit?: (model: T, valid: boolean, validationResponses: Record<string, FormValidation>, activeID: string | null) => void
  ref?: ForwardedRef<HTMLFormElement | null>
  updateModel: (model: T) => void
  validateOn?: FormValidationAction
}

export interface FormElementProps {
  children?: React.ReactNode
  className?: string
  disabled?: boolean
  id?: string
  modelKey: string
  startTouched?: boolean
  triggersValidation?: DependencyList
  validations?: FormValidationFunction<unknown>[]
}
